module.exports = __webpack_public_path__ + "static/media/8.f9e0a5cd.PNG";